<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="110" :model="formFields" :rules="ruleValidate">
        <FormItem label="产品类型:" prop="itemType">
          <RadioGroup v-model="formFields.itemType" @on-change="onItemTypeChange">
            <Radio :label="0" :true-value="0">
              包月
            </Radio>
            <Radio :label="1" :true-value="1">
              临停
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="绑定车库:" prop="parkingId">
          <Select
            v-model="formFields.parkingId"
            :loading="selectLoading"
            size="small"
            placeholder="请选择绑定车库..."
            clearable
            filterable
            @on-change="handleParkingChange"
          >
            <Option v-for="(option, index) in garages" :key="index" :value="option.id" :label="option.name" />
          </Select>
        </FormItem>
        <FormItem v-if="formFields.itemType === 0" label="车辆类型:" prop="vehicleType">
          <Select
            v-model="formFields.vehicleType"
            clearable
            filterable
            placeholder="请选择车辆类型..."
            size="small"
          >
            <Option v-for="item in types" :key="item.id" :value="item.id" :label="item.name" />
          </Select>
        </FormItem>
        <FormItem label="产品类别:" prop="productId">
          <Select
            v-model="formFields.productId"
            :loading="selectLoading"
            size="small"
            placeholder="请选择绑定车库..."
            clearable
            filterable
          >
            <Option v-for="(option, index) in products" :key="index" :value="option.id" :label="option.name" />
          </Select>
        </FormItem>
        <FormItem label="产品名:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入产品名称..." size="small" />
        </FormItem>
        <FormItem label="产品报价(元):" prop="price">
          <Input v-model="formFields.price" placeholder="请输入产品报价..." size="small" />
        </FormItem>
        <FormItem :label="formFields.itemType === 0 ? '套餐月份' : '套餐小时' + ''" prop="month">
          <Input v-model="formFields.month" placeholder="请输入月份数..." size="small" />
        </FormItem>
        <FormItem :label="formFields.itemType === 0 ? '赠送天数' : '赠送分钟' + ''" prop="freeDays">
          <Input v-model="formFields.freeDays" placeholder="请输入赠送天数..." size="small" number />
        </FormItem>
        <FormItem label="排序:" prop="sort">
          <Input v-model="formFields.sort" placeholder="请输入产品排序..." size="small" number />
        </FormItem>
        <FormItem label="备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入产品备注..." size="small" />
        </FormItem>
        <FormItem label="启用:" prop="visible">
          <RadioGroup v-model="formFields.visible">
            <Radio :label="1" :true-value="1">
              是
            </Radio>
            <Radio :label="0" :true-value="0">
              否
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
      <div style="font-size: 12px; text-align: right; color: #69c">
        <Icon type="md-information-circle" /> 倘若不选择绑定车库，则产品报价将适用于其他车库。
      </div>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'ProductQuotationDialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    pid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      garages: this.loadGarages(),
      products: this.loadProducts(),
      types: [],
      loadingStatus: false,
      selectLoading: false,
      modal: true,
      submit: false,
      formFields: {
        parkingId: '',
        productId: '',
        visible: 1,
        itemType: 0,
        name: '',
        price: '',
        remarks: '',
        vehicleType: '',
        id: this.id,
        sort: 0,
        month: 1,
        freeDays: 0
      },
      ruleValidate: {
        productId: [
          { required: true, message: '产品类别不能为空!' }
        ],
        name: [
          { required: true, message: '产品名不能为空!', trigger: 'blur' }
        ],
        month: [
          { required: true, message: '产品月份数必须为整数且不为0!', trigger: 'blur', pattern: /^[0-9]+$/ }
        ],
        price: [
          { required: true, message: '产品报价必须为整数或者浮点数!', trigger: 'change', pattern: /^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/ }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑产品报价' : '添加产品报价'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.loadData()
    }
  },
  methods: {
    onItemTypeChange(type) {
      if (type) {
        this.vehicleType = ''
      }
    },
    loadData() {
      const _this = this
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          applyObject(res.data, _this.formFields)
          _this.loadVehicleTypes(_this.formFields.parkingId)
          _this.loadingStatus = false
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      } else {
        this.loadVehicleTypes(0)
      }
    },
    async loadVehicleTypes(parkingId) {
      const host = this.$config.apiContextPath + '/vehicle/type?fetchAll=true' + (parkingId ? '&parkingId=' + parkingId : '')
      await request({
        url: host,
        method: 'get'
      }).then(res => {
        this.types = res.data.content
      }).catch(error => {
        console.log(error)
        this.types = []
      })
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = res.data
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async loadProducts() {
      await request({
        url: this.$config.apiContextPath + '/product',
        method: 'get'
      }).then(res => {
        this.products = res.data.content
      }).catch(error => {
        console.log(error)
        this.products = []
      })
    },
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            request({
              url: this.action + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({
                title: '数据保存成功',
                desc: '产品报价 `' + this.formFields.name + '` 保存成功!'
              })
              this.submit = false
              this.closeModal(true)
            }).catch(() => {
              // this.$Notice.error({
              //   title: '服务器数据请求失败',
              //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
              // })
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    handleParkingChange(parkingId) {
      const query = parkingId ? '&parkingId=' + parkingId : ''
      request({
        url: this.$config.apiContextPath + '/vehicle/type?bypass=1&fetchAll=true' + query,
        method: 'get'
      }).then(res => {
        this.types = res.data.content
        this.formFields.vehicleType = ''
      }).catch(error => {
        this.$Notice.error({
          title: '服务器数据请求失败',
          desc: '获取车库绑定车型失败'
        })
        console.log(error)
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
